import { TabType, useGoToReviewList, usePdpConfig, useProductPreviewAtiveTabType } from '@domains/pdp-common';

import { Ratings } from '../components/Ratings';
import { ViewReveiwText } from '../components/ViewReviewText';
import { useRatingUBL } from '../log/useRatingUBL';
import { useRatingsService } from '../services/useRatingsService';
export interface RatingsContainerProps {
  className?: string;
}

export const RatingsContainer: React.FC<React.PropsWithChildren<RatingsContainerProps>> = ({ className }) => {
  const { is_hide, ratings_average, review_count, is_in_app, is_browser, handleClickViewAll, product_id } =
    useRatingsService();
  const { goToReviewList } = useGoToReviewList();
  const { isProductPreview } = usePdpConfig();
  const [_, setProductPreviewActiveTabType] = useProductPreviewAtiveTabType();
  const ubl = useRatingUBL();
  if (is_hide) {
    return null;
  }
  return (
    <Ratings
      className={className}
      ratings_average={ratings_average}
      review_count={review_count}
      display_review_count={is_in_app && is_browser && !isProductPreview}
      onClickViewAll={handleClickViewAll}
      after_addon={
        (!is_in_app || isProductPreview) &&
        review_count > 0 && (
          <ViewReveiwText
            count={review_count.toLocaleString()}
            onClick={() => {
              ubl.viewReviewTab(product_id);
              isProductPreview ? setProductPreviewActiveTabType(TabType.REVIEW) : goToReviewList();
            }}
          />
        )
      }
    />
  );
};
